import { createFileRoute } from '@tanstack/react-router';

import { FeedbackPage } from '@/features/Feedback/FeedbackPage';

export const Route = createFileRoute('/feedback')({
    component: FeedbackPage,
});
